import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { motion } from "framer-motion";

// Components
import Header from "./components/Header";
import HeroSlider from "./components/HeroSlider";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import PortfolioGrid from "./components/PortfolioGrid";
import PricingSection from "./components/PricingSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Custom cursor effect (optional enhancement)
    const handleMouseMove = (e) => {
      const cursor = document.getElementById('custom-cursor');
      if (cursor) {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        {/* Custom Cursor (Desktop only) */}
        <div
          id="custom-cursor"
          className="hidden md:block fixed w-6 h-6 border-2 border-gold rounded-full pointer-events-none z-[9999]"
          style={{ transform: 'translate(-50%, -50%)' }}
        />

        {/* Page Layout */}
        <Header />
        
        <main>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <section id="home">
              <HeroSlider />
            </section>
            
            <section id="about">
              <AboutSection />
            </section>
            
            <section id="services">
              <ServicesSection />
            </section>
            
            <section id="paketler">
              <PricingSection />
            </section>
            
            <section id="portfolio">
              <PortfolioGrid />
            </section>
            
            <section id="sss">
              <FAQSection />
            </section>
            
            <section id="contact">
              <ContactSection />
            </section>
          </motion.div>
        </main>
        
        <Footer />
        
        {/* WhatsApp Floating Button */}
        <WhatsAppButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
